import React from 'react';
import { Box, Chip, Autocomplete, TextField } from '@mui/material';
import { wikiTheme } from '../wikiTheme';

/**
 * Component for managing nicknames on wiki entries as chips
 * Stores as comma-separated string internally
 */
const NicknamesEditor = ({ nicknames = '', onChange }) => {
  // Convert comma-separated string to array
  const nicknamesArray = nicknames ? nicknames.split(',').map(n => n.trim()).filter(n => n) : [];

  const handleChange = (event, newValue) => {
    // Convert array back to comma-separated string
    const nicknamesString = newValue.join(', ');
    onChange(nicknamesString);
  };

  return (
    <Box>
      <Autocomplete
        multiple
        freeSolo
        value={nicknamesArray}
        onChange={handleChange}
        options={[]} // No preset options, user can type anything
        renderInput={(params) => (
          <TextField
            {...params}
            label="Nicknames"
            placeholder="Type a nickname and press Enter"
            helperText="Alternative names that can be used to find this entry in Benny's Journal"
            sx={{
              '& .MuiOutlinedInput-root': {
                color: wikiTheme.secondary,
                fontFamily: wikiTheme.font,
                '& fieldset': {
                  borderColor: wikiTheme.lightGray,
                },
                '&:hover fieldset': {
                  borderColor: wikiTheme.primary,
                },
                '&.Mui-focused fieldset': {
                  borderColor: wikiTheme.primary,
                },
              },
              '& .MuiInputLabel-root': {
                color: wikiTheme.tertiary,
                fontFamily: wikiTheme.font,
              },
              '& .MuiInputLabel-root.Mui-focused': {
                color: wikiTheme.primary,
              },
              '& .MuiFormHelperText-root': {
                color: wikiTheme.tertiary,
                fontFamily: wikiTheme.font,
              },
            }}
          />
        )}
        renderTags={(value, getTagProps) =>
          value.map((option, index) => (
            <Chip
              {...getTagProps({ index })}
              key={option}
              label={option}
              sx={{
                backgroundColor: wikiTheme.primary,
                color: wikiTheme.dark,
                fontFamily: wikiTheme.font,
                '& .MuiChip-deleteIcon': {
                  color: wikiTheme.dark,
                  '&:hover': {
                    color: '#8b0000',
                  },
                },
              }}
            />
          ))
        }
        sx={{
          '& .MuiAutocomplete-tag': {
            margin: '2px',
          },
        }}
      />
    </Box>
  );
};

export default NicknamesEditor;
